import React, { FC } from 'react';
import styled from 'styled-components';
import { useListKeys } from '../../hooks/useListKeys';
import { ClickEvent, SelectionOptionContext } from './Context';

interface ISelectionOptionProps {
    focusFirstElement?: boolean;
    selector?: string;
    onItemClick?: (e: ClickEvent) => void;
}

export const SelectionOption: FC<ISelectionOptionProps> = ({ children, focusFirstElement = false, selector, onItemClick }) => {
    const { listRef } = useListKeys(focusFirstElement, selector);

    const handleClick = (e: ClickEvent) => {
        if (onItemClick) {
            onItemClick(e);
        }
    };

    return (
        <SelectionOptionContext.Provider value={{ onItemClick: handleClick }}>
            <ListUl ref={listRef}>{children}</ListUl>
        </SelectionOptionContext.Provider>
    );
};

const ListUl = styled.ul`
    padding: 0;
    margin: 0;
    list-style: none;
`;
